import React from 'react'
import { DialogActions, DialogActionsProps } from '@material-ui/core'
import { createStyles, Theme, withStyles } from '@material-ui/core/styles'

interface IYumDialogActions extends DialogActionsProps {}

const YumDialogActions = withStyles((theme: Theme) =>
  createStyles({
    root: { padding: '24px 24px 0 24px', display: 'flex', gap: '24px', width: '100%' },
  }),
)(({ children, classes, ...props }: IYumDialogActions) => {
  return (
    <DialogActions classes={classes} {...props}>
      {children}
    </DialogActions>
  )
})

export default YumDialogActions
